<div style="display: flex; height: 100%;">
  <div class="left-column">
    <button mat-mini-fab color="primary" class="add-report-button" (click)="createReport()" matTooltip="Create new report"><mat-icon>add</mat-icon></button>
    <div class="card-container">
      <div *ngFor="let report of searchReports">
        <div style="display: flex; flex-direction: row;">
          <div *ngIf="isSelectedReport(report)" style="padding-bottom: 21px">
            <div class="selected-item"></div>
          </div>
          <mat-card (click)="setReport(report)" class="card-list" style="width: 100%; margin: 10px 10px 10px 20px;" [ngClass]="{'selected': isSelectedReport(report)}">
            <mat-card-title>
              <div *ngIf="editReportId === report.searchReportId;else report_title" style="width: 100%;">
                <mat-form-field style="flex: auto; width: 100%;">
                  <input matInput (blur)="updateReport(report)" (keyup.enter)="updateReport(report)" [(ngModel)]="report.title">
                </mat-form-field>
              </div>
              <ng-template #report_title>
                {{report.title}}
              </ng-template>
              <div>
                <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editReportId = report.searchReportId">Rename</button>
                  <div *ngIf="report.runStatus === ReportStatus.Created;else post_run_menu">
                    <button mat-menu-item (click)="selectFilter()">Filter</button>
                  </div>
                  <ng-template #post_run_menu>
                    <button mat-menu-item (click)="cloneReport(report)">Clone</button>
                  </ng-template>
                  <button mat-menu-item [disabled]="report.runStatus === ReportStatus.Running" (click)="deleteReport(report)">Delete</button>
                </mat-menu>
              </div>
            </mat-card-title>
            <mat-card-subtitle style="flex-direction: column">
              <div>{{ (report.runStatus === ReportStatus.Created ? report.dateTimeCreated : report.dateTimeRun) | date:'M/d/yyyy h:mm:ss a' }}</div>
              <div>{{ getCreatedByName(report.createdById) }}</div>
            </mat-card-subtitle>
            <mat-card-content>
              <div style="box-sizing: border-box; display: flex; place-content: center space-evenly; align-items: center;">
                <h3>{{report.searchReportQueries.length | number}} Terms</h3>
                <div *ngIf="report.runStatus === ReportStatus.Created;else queued">
                  <button mat-button [disabled]="report.searchReportQueries.length === 0" color="primary" (click)="addSearchReortJobToQueue(report)">Run</button>
                </div>
                <ng-template #queued>
                  <div *ngIf="report.runStatus === ReportStatus.Running;else total_hit_count">
                    <h3>Processing...</h3>
                  </div>
                  <ng-template #total_hit_count>
                    <h3>{{getTotalHitCount(report.searchReportQueries) | number}} Total Hits</h3>
                  </ng-template>
                </ng-template>
              </div>
              <mat-error *ngIf="isSelectedReport(report) && report.runStatus === ReportStatus.Error">The Search Term Report encountered an error. <br /> The results might be inaccurate. <br /> Please contact Professional Services.</mat-error>
              <div *ngIf="isSelectedReport(report)">
                <div style="display: flex; flex-direction: column;">
                  <div *ngIf="report.filterId" class="filter-string">
                    <mat-label style="font-size:12px;">Filter</mat-label>
                    <div style="padding-left: 5px">
                      {{filterString}}
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <div class="right-column">
    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; width: 100%;">
      <mat-toolbar color="primary" class="toolbar-over-card" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;">
        <button (click)="navigateToBrowse()" class="unstyled-button">
          {{ selectedReport ? selectedReport.title : 'Search Report'}}
        </button>
        <div *ngIf="selectedReport ? selectedReport.runStatus === ReportStatus.Done : false">
          <button mat-icon-button (click)="isGraphView = !isGraphView" [matTooltip]="isGraphView ? 'View Data Results' : 'View Graph'">
            <mat-icon>{{ toggleIcon() }}</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menuRight"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #menuRight="matMenu">
            <button mat-menu-item (click)="exportToLog()">Export</button>
          </mat-menu>
        </div>
        <div *ngIf="selectedReport ? selectedReport.runStatus === ReportStatus.Created : false">
          <button mat-icon-button (click)="showAddQueryDialog()"><mat-icon>add</mat-icon></button>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="height: 100%; padding-bottom: 0; overflow: hidden;">
        <mat-card-content style="height: 100%; margin-bottom: 0px; overflow: auto;">
          <div *ngIf="searchReports.length === 0;else show_select">
            Please create a report
          </div>
          <ng-template #show_select>
            <ng-container *ngIf="!selectedReport;else show_report_details">
              Please select a report
            </ng-container>
          </ng-template>
          <ng-template #show_report_details>
            <div *ngIf="legacySearchSyntaxWarning.length > 0">
              <div *ngFor="let warning of legacySearchSyntaxWarning" class="alert">
                <div>{{warning}}</div>
                <button mat-button (click)="clearWarning(warning)">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </div>
            <lex-search-report-queries [reportQueryDataSource]="selectedReport.searchReportQueries" [report]="selectedReport"
                                       [isGraphView]="isGraphView" (deletedQuery)="removeReportQuery($event)" style="height: 100%">
            </lex-search-report-queries>
          </ng-template>
        </mat-card-content>
        <mat-card-footer class="info-text" style="padding: 10px 0; font-size: 10px; text-align: center;">
          <div *ngIf="isGraphView;else show_table_results_message">
            Clicking the bar graph will filter on the cached results of the time the report was run on Browse.
          </div>
          <ng-template #show_table_results_message>
            Clicking on the query will run the query again through Search.
          </ng-template>
        </mat-card-footer>
        </mat-card>
    </div>
  </div>
</div>
